import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { postMiscAttachment, deleteAttachmentInBucket } from "../../Actions/CommonAPI";
import { getLookupList } from "../../Actions/lookupAPI";
import AddIcon from "../../UIComponents/AddIcon";
import MinusIcon from "../../UIComponents/MinusIcon";
import axios from "axios";
import API from "../../helpers/api";
import { toast } from "react-toastify";
import {getFlagList,getClassList,getTypeofShipList,getMiscTypeList,getEquipmentNameListAndId} from "../../Actions/helpersAPI";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import { validateFields } from "../../Utils/utilities"
import Autocomplete from "react-autocomplete";
import { confirmAlert } from "react-confirm-alert";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import $ from "jquery";


let currentuser = JSON.parse(localStorage.getItem("currentUser"));
var fileDatas = [];

class MiscAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      miscinfo: {
        countryname: "",
        attachmentName: "",
        attachmentGuid: "",
        lookupmisc:"",
        createdBy: currentuser.name,
        miscType:"",
        typeValue:"",
        equipmentName: "",
        equipmentId: 0,
        capacity: "",
        category: "",
        equipmentType: "",
      },
      file: "",
      fileName: "",
      modalIsOpen: false,
      ship: false,
      shore: false,
      ApplicableServices: [],
      ApplicableServicesList: [],
      ServiceTypeList:[],
      isMiscNew: true,
      selectedServiceYears:[],
      lookUpType:"misc",
      ServiceYearList:[],
      AddServiceYear: [
        {
          Id: 0,
          serviceTypeId: 0,
          equipmentId: 0,
          equipmentName: "",
          capacity: "",
          category: "",
          equipmentType: "",
          typeValue:"",
          serviceType: "",
          servicetypelist: [],
          isShore: false,
          radioButton: "",
          isDeleted: false,
        },
      ],
      openTypeValue: false,
      openEquipment: false,
    };
    this.AddMisc = this.AddMisc.bind(this);
    this.handleInputChanges = this.handleInputChanges.bind(this);
    this.autocompleteRef = React.createRef();
  }

 async componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Misc" });
    dispatch({type: "MiscApplicableServices",data: []});
    dispatch(getEquipmentNameListAndId());
    dispatch(getFlagList());
    dispatch(getMiscTypeList());
    dispatch(getClassList("class"));
    dispatch(getTypeofShipList("typeofship"));
    await axios.get(`${API.GetServiceTypeList}`).then((res) => {
      let list = [];
      let serviceTypeList = []
      res.data.map((item, index) => {
        let listItem = item.serviceTypes.split(" ");
        let order = (listItem[0])
        let id = item.id;
        list.push({ id,order});
      });
      let mainList = list.sort(function (a, b) {
        return  a.order - b.order;
      })
      mainList.map((item, i) => {
        let serviceTypes = item.order + " yearly";
        item = item.id;
        serviceTypeList.push({
          item,
          serviceTypes,
        });
      });
      this.state.AddServiceYear[0].servicetypelist = serviceTypeList;
      this.setState({ ServiceTypeList: serviceTypeList,
        ServiceYearList:serviceTypeList,
      });
    });
   
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { MiscAttachment, MiscapplicableServiceType, dispatch } = nextProps;
    if (MiscAttachment) {
      prevState.miscinfo.attachmentName = MiscAttachment.FileName;
      prevState.miscinfo.attachmentGuid = MiscAttachment.Guid;
    }

    if (prevState.file !== "") {
      dispatch(postMiscAttachment(prevState.file));
      prevState.file = "";
    }
    if (
       MiscapplicableServiceType &&
       MiscapplicableServiceType !== "" &&
      prevState.ApplicableServices &&
      prevState.ApplicableServices.length === 0
    ) {
      dispatch({ type: "getServiceTypeIntervalListMiscSuccess", data: "" });
      prevState.ApplicableServices =
      MiscapplicableServiceType.length &&
        MiscapplicableServiceType.map((d, i) => {
          let obj = {
            serviceType: 0,
            serviceTypeId: "",
            equipmentId: prevState.miscinfo.equipmentId,
            equipmentName: prevState.miscinfo.equipmentName,
            capacity: prevState.miscinfo.capacity,
            category: prevState.miscinfo.category,
            equipmentType: prevState.miscinfo.equipmentType,
            isShore: false,
            radioButton: "",
            isDeleted:false
          };
          return obj;
        });
    }
  }

  AddMisc() {
    const { dispatch,t } = this.props;
    if(this.state.miscinfo.lookupmisc !=="" && this.state.miscinfo.miscType !=="" && this.state.ApplicableServicesList.length>0){
      let url1=`${API.miscExist}?MiscName=${this.state.miscinfo.lookupmisc}&MiscId=0&Type=${this.state.miscinfo.miscType}`;
      axios.get(url1).then((response) => {
        if(response.data ===true){
      let lookup = {
      lookUpToAdd: "lookup",
      lookUpType: this.state.lookUpType,
      lookUpValue:this.state.miscinfo.lookupmisc,
      createdBy: currentuser.name,
      miscType:this.state.miscinfo.miscType,
      miscAttachmentGuid:this.state.miscinfo.attachmentGuid,
      miscAttachmentName: this.state.miscinfo.attachmentName,
      IntervalYear: 0,
    };
    let url = `${API.postlookup}`;
    axios
      .post(url,lookup)
      .then((response) => {
        if (response.data) {
          let data = {
            miscId: response.data,
            type: this.state.miscinfo.miscType,
            miscApplicableServices: this.state.ApplicableServicesList,
            createdBy: currentuser.email,
          };
          let url2 = `${API.postMiscApplicableService}`;
          axios
            .post(url2, data)
            .then((res) => {
              let searchData = {
                LookUpToSearch: this.state.lookUpType,
                LookUpName: "",
                PageNumber: 1,
                PageSize: 20
              };
           
              if (fileDatas.length > 0) {
                this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                fileDatas = [];
              } 
              dispatch(getLookupList(searchData));
              this.CancelAddMisc();
              toast.success(`${t("CommonText.CommonAdd")}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              dispatch({
                type: "MiscApplicableServices",
                data: [],
              });
              dispatch({
                type: "postMiscApplicableServiceSuccess",
                data: res.data,
              });
            })
            .catch((error) => {
              // swal("Error!", "Something went wrong. Please try again.", "warning");
              swal({
                title: t('SwalError.ErrorTitle'), 
                text: t('CommonText.500ErrorMessage'),  
                icon: 'warning',  
                buttons: {
                  confirm: {
                    text: t('confirmAlertMessage.Ok')
                  }
                }
              });
              dispatch({
                type: "postMiscApplicableServiceFailure",
                error: "ERROR",
              });
            });
        }
        dispatch({
          type: "postMiscDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        // swal("Error!", "Something went wrong. Please try again.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t('CommonText.500ErrorMessage'),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
        dispatch({
          type: "postMiscDetailFailure",
          error: "ERROR",
        });
      });
    }
    else if(response.data === false){
      // swal(
      //   "Error!",
      //   `${t("MiscScreenContent.WarningMsg")}`,
      //   "warning"
      // );
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('MiscScreenContent.WarningMsg'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
      this.state.miscinfo.lookupmisc="";
      this.setState({});
    }
    dispatch({
      type: "getMiscExistListSuccess",
      data: response.data,
    });
    
  })
  .catch((error) => {
    dispatch({
      type: "getMiscExistListFailure",
      data: "error",
    });
  }); 
  }else if(this.state.miscinfo.lookupmisc==="" && this.state.miscinfo.miscType ==="" &&this.state.ApplicableServicesList.length==0){
    // swal("Error!", "Misc name and Misc type is mandatory.", "warning");
    swal({
      title: t('SwalError.ErrorTitle'), 
      text: t('SwalError.Misc'),  
      icon: 'warning',  
      buttons: {
        confirm: {
          text: t('confirmAlertMessage.Ok')
        }
      }
    });
  }else if(this.state.miscinfo.lookupmisc===""){
    // swal("Error!", "Misc name is mandatory.", "warning");
    swal({
      title: t('SwalError.ErrorTitle'), 
      text: t('SwalError.MiscName'),  
      icon: 'warning',  
      buttons: {
        confirm: {
          text: t('confirmAlertMessage.Ok')
        }
      }
    });
  }else if(this.state.miscinfo.miscType===""){
    // swal("Error!", "Misc Type is mandatory.", "warning");
    swal({
      title: t('SwalError.ErrorTitle'), 
      text: t('SwalError.MiscType'),  
      icon: 'warning',  
      buttons: {
        confirm: {
          text: t('confirmAlertMessage.Ok')
        }
      }
    });
  }else if(this.state.ApplicableServicesList.length===0){
    // swal("Error!", "Misc Type is mandatory.", "warning");
    swal({
      title: t('SwalError.ErrorTitle'), 
      text: "Applicable service",  
      icon: 'warning',  
      buttons: {
        confirm: {
          text: t('confirmAlertMessage.Ok')
        }
      }
    });
  }
  
  
  }
  deleteApplicableType = (index) => {
    const {t}=this.props;
    confirmAlert({
      message:`${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label:`${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            this.state.ApplicableServicesList.splice(index, 1);
            this.setState({});
          },
        },
        {
          label:`${t("confirmAlertMessage.No")}`,
          onClick: () => {},
        },
      ],
    });
  };
   handleSelectChange(value, field, item) {
    this.state.miscinfo[field] = value;
    var lineitems = this.state.AddServiceYear;
    lineitems &&
      lineitems.map((a, i) => {
        a.typeValue = value;
      });
   this.setState({ AddServiceYear: lineitems });
  }
  handleFileInputChange(e) {
    let nodeName = e.target.name;
    const {t}=this.props
    if (nodeName === "fileName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) { 
      this.setState({
        file: e.target.files[0],
        fileName: e.target.files[0].name,
      });}else{
        // swal(
        //   "Error!",
        //   "Please upload the file without special characters.",
        //   "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t('SwalError.UploadFile'),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
       return;
      }
    }
  }
  handleEquipmentSelectChange(value, field, item) {
    const{t}=this.props
    if(this.state.miscinfo.miscType !==""){
      if(this.state.miscinfo.typeValue !==""){
    this.state.miscinfo[field] = value;
    this.state.miscinfo.equipmentId = item.equipmentId;
    this.state.miscinfo.category = item.category;
    this.state.miscinfo.capacity = item.capacity;
    this.state.miscinfo.equipmentType = item.equipmentType;
    if (this.state.ApplicableServicesList.length > 0) {
      let arrayYears = [];
      let result = [];
      let result1 = this.state.ServiceTypeList;
      let result2 = this.state.ApplicableServicesList.filter((i) => i.equipmentId === item.equipmentId && i.typeValue===this.state.miscinfo.typeValue);
      if(result2.length !==0){
        result2.map((j) => {arrayYears.push(j.serviceTypeId);});
        result = result1.filter(function (obj) {return arrayYears.indexOf(obj.item) === -1;});
        this.state.AddServiceYear[0].servicetypelist = result;
      }else{
        let result4 = this.state.ServiceTypeList;
        this.state.AddServiceYear[0].servicetypelist = result4;
      }
     this.setState({})
    }
    var lineitems = this.state.AddServiceYear;
    lineitems &&
      lineitems.map((a, i) => {
        a.typeValue=lineitems[0].typeValue;
        a.equipmentId = item.equipmentId;
        a.equipmentName = value;
        a.capacity = item.capacity;
        a.category = item.category;
        a.equipmentType = item.equipmentType;
      });
    this.setState({ AddServiceYear: lineitems });
    this.autocompleteRef.current.blur();
    this.showMiscModal(0, true);
      }else{
        swal("Error!",`Please select the ${this.state.miscinfo.miscType}.`,"warning" );
      }
    }else{
      // swal("Error!","Please select the type.","warning" );
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('SwalError.Please'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    }
  }
  showMiscModal = (MiscId, isMiscNew, EquipId) => {
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    if (MiscId > 0) {
      let response = this.state.ApplicableServicesList.filter((item) => item.Id === MiscId && item.equipmentId === EquipId);
      let editModelDetails = response[0];
      var lineitems = this.state.AddServiceYear;
      lineitems &&
        lineitems.map((a, i) => {
          a.Id = parseInt(editModelDetails.Id);
          a.typeValue=editModelDetails.typeValue;
          a.equipmentId = editModelDetails.equipmentId;
          a.equipmentName = editModelDetails.equipmentName;
          a.capacity = editModelDetails.capacity;
          a.category = editModelDetails.category;
          a.equipmentType = editModelDetails.equipmentType;
          a.serviceTypeId = editModelDetails.serviceTypeId;
          a.serviceType = editModelDetails.serviceType;
          a.radioButton = editModelDetails.isShore ? "Shore" : "Ship";
          a.isDeleted=false;
    });
        let arrayYears = [];
        let result = [];
        let currentvalue=[];
        let result1 = this.state.ServiceTypeList;
        let result2 = this.state.ApplicableServicesList.filter((i) => i.equipmentId ===  editModelDetails.equipmentId && i.typeValue===this.state.miscinfo.typeValue);
          result2.map((j) => {arrayYears.push(j.serviceTypeId)});
          currentvalue=result1.filter((i)=>i.item===editModelDetails.serviceTypeId)
          result = result1.filter(function (obj) {return arrayYears.indexOf(obj.item) === -1;});
        let finalResult= [...currentvalue,...result];
        let list = [];
        let newServiceTypeList = []
        finalResult.map((j, index) => {
          let listItem = j.serviceTypes.split(" ");
          let order = (listItem[0])
          let id = j.item;
          list.push({ id,order});
        });
        let mainList = list.sort(function (a, b) {
          return  a.order - b.order;
        })
        mainList.map((item, i) => {
          let serviceTypes = item.order + " yearly";
          item = item.id;
          newServiceTypeList.push({
            item,
            serviceTypes,
          });
        });
        this.state.AddServiceYear[0].servicetypelist = newServiceTypeList;
      this.setState(
        {
         modalIsOpen: !this.state.modalIsOpen,
          isMiscNew: isMiscNew,
          AddServiceYear: lineitems,
        },
        () => console.log(this.state.isMiscNew)
      );
    } else {
      var lineitems = this.state.AddServiceYear;
      lineitems &&
        lineitems.map((a, i) => {
          a.Id = arrayLength >= 0 ? arrayLength + 1 : 0;
        });
      this.setState(
        {
          isMiscNew: isMiscNew,
          AddServiceYear: lineitems,
          modalIsOpen: !this.state.modalIsOpen,
        },
        () => {
          console.log("addservice", this.state.AddServiceYear);
          console.log("model", this.state.modalIsOpen);
          this.ClearServiceYear();
        }
      );
    }
  };
  addApplicableType = () => {
    const { dispatch,t } = this.props;
    if (this.state.AddServiceYear.length > 0) {
      let isValidMiscCharge = this.miscChargeValidation();
      if (!isValidMiscCharge) {
        return;
      }
    }
    if (this.state.AddServiceYear.length <= 0) {
      // swal("Error!", `${t("ClassScreen.ErrorMsg")}`, "warning");
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('ClassScreen.ErrorMsg'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
      });
    } else {
      let GetClass = this.state.ApplicableServicesList;
       let temp = GetClass.filter(
        (j) =>
          j.equipmentId === this.state.AddServiceYear[0]?.equipmentId &&
          j.Id === this.state.AddServiceYear[0]?.Id
      );
     if (temp.length > 0) {
         GetClass.forEach((ele, index) => {
          if (
            ele.Id === this.state.AddServiceYear[0]?.Id &&
            ele.equipmentId === this.state.AddServiceYear[0]?.equipmentId
          ) {
            GetClass[index] = this.state.AddServiceYear[0];
          }
        });
      
      } else {
        GetClass.push(...this.state.AddServiceYear);
      }
      dispatch({
        type: "MiscApplicableServices",
        data: this.state.ApplicableServicesList,
      });
      this.state.miscinfo.equipmentName="";
      this.state.miscinfo.equipmentId=0;
      this.state.miscinfo.capacity="";
      this.state.miscinfo.category="";
      this.setState({ modalIsOpen: false }, () => {
        this.ClearServiceYear();
      });
    }
  };

  miscChargeValidation() {
    const{t}=this.props;
    let validateField = [];
    let inValidComponent = [];
    let length = this.state.AddServiceYear.length;
    let miscCharges = this.state.AddServiceYear.filter(
      (item) => item.isDeleted === false
    );
    if (
      $("#chargeDescription0").val() === "" ||
      miscCharges[0].radioButton === ""
    ) {
      if ($("#chargeDescription0").val() === "") {
        $("#chargeDescription0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#chargeDescription0ErrMsg").text("");
      }
    if (miscCharges[0].radioButton === "") {
        $("#isUnitPrice0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#isUnitPrice0ErrMsg").text("");
      }
      return;
    } else {
      $("#chargeDescription0ErrMsg").text("");
      $("#isUnitPrice0ErrMsg").text("");
    }
    let indexFrom =
      $("#chargeDescription0").val() === "" &&
      miscCharges[0].radioButton === "" ?  1: 0;
    miscCharges.forEach((row, index) => {
      if (index >= indexFrom) {
        validateField.push(
          { Id: `chargeDescription${index}`, Type: "text" },
        );
        if (row.radioButton == "") {
          inValidComponent.push(`isUnitPrice${index}`);
          $("#isUnitPrice" + index + "ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
        } else {
          $("#isUnitPrice" + index + "ErrMsg").text("");
          var itemIndex = inValidComponent.indexOf(`isUnitPrice${index}`);
          if (itemIndex != -1) {
            inValidComponent.splice(itemIndex, 1);
          }
        }
      }
    });
    const validationResult = validateFields(validateField, true);
    validationResult.InValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
    });
    validationResult.ValidFields.forEach((element, index) => {
      $("#" + element.Id + "ErrMsg").text("");
    });
    if (validationResult.IsValid===true && inValidComponent.length ===0) {
      return true;
    } else {
      return false;
    }
  
  }
  AddNewServiceYear() {
    let isValidMiscCharge = this.miscChargeValidation();
    if (!isValidMiscCharge) {
      return;
    }
    let result = [];
    let selectedValue=[];
    let result1 = this.state.ServiceTypeList;
    var arrayStroage = this.state.AddServiceYear;
    var arrayLength = 0;
    selectedValue= this.state.ApplicableServicesList.filter(item=> item.equipmentId===arrayStroage[0].equipmentId && item.typeValue===arrayStroage[0].typeValue)
    let result2 = this.state.selectedServiceYears;
    if(selectedValue.length !==0){
      selectedValue.map((i)=>(
        result2.push(i.serviceTypeId)
      ))
    }
   console.log("selected", this.state.selectedServiceYears);
    result = result1.filter(function (obj) {
      return result2.indexOf(obj.item) === -1;
    });
   if(this.state.ApplicableServicesList.length > 0 && this.state.AddServiceYear.length>0){
        arrayLength=this.state.ApplicableServicesList.length+this.state.AddServiceYear.length;
   }
    else if (this.state.ApplicableServicesList.length > 0) {
      arrayLength = this.state.ApplicableServicesList.length;
    } else {
      arrayLength = this.state.AddServiceYear.length;
    }
    console.log("service years:", result);
    this.setState({
      AddServiceYear: [
        ...this.state.AddServiceYear,
        {
          Id: arrayLength + 1,
          serviceTypeId: 0,
          equipmentId: arrayStroage[0].equipmentId,
          equipmentName: arrayStroage[0].equipmentName,
          capacity: arrayStroage[0].capacity,
          category: arrayStroage[0].category,
          equipmentType: arrayStroage[0].equipmentType,
          typeValue: arrayStroage[0].typeValue,
          servicetypelist: result,
          isShore: false,
          radioButton: "",
          isDeleted:false
        },
      ],
    });
  }
  handleSelectYear = (e, i) => {
    let value = parseInt(e.target.value);
    let ServiceTypeList = this.state.ServiceTypeList.filter((i) => i.item === value);
    let x = this.state.selectedServiceYears;
    x.push(value);
    this.setState({ selectedServiceYears: x });
    console.log("selected", this.state.selectedServiceYears);
    let AddServiceYear = this.state.AddServiceYear;
    AddServiceYear[i][e.target.name] = parseInt(e.target.value);
    AddServiceYear[i]["serviceType"] = ServiceTypeList[0].serviceTypes;
    this.setState({ AddServiceYear });
  };
  DeleteServiceYear(index) {
    const serviceCharges = [...this.state.AddServiceYear];
    serviceCharges.splice(index, 1);
    if(this.state.selectedServiceYears.length > 1)
    {
    const selectedServiceYear = [...this.state.selectedServiceYears];
    selectedServiceYear.splice(index, 1);
    this.state.selectedServiceYears = selectedServiceYear;
    this.setState({})
    }
    this.state.AddServiceYear = serviceCharges;
    this.setState({});
  }
  ClearServiceYear() {
    var arrayStroage = this.state.ApplicableServicesList;
    var arrayLength = arrayStroage.length;
    this.setState({
      AddServiceYear: [
        {
          Id: arrayLength >= 0 ? arrayLength + 1 : 0,
          serviceTypeId: 0,
          equipmentId: this.state.miscinfo.equipmentId,
          equipmentName: this.state.miscinfo.equipmentName,
          capacity: this.state.miscinfo.capacity,
          category: this.state.miscinfo.category,
          equipmentType: this.state.miscinfo.equipmentType,
          typeValue:this.state.miscinfo.typeValue,
          serviceType: "",
          servicetypelist: this.state.AddServiceYear[0].servicetypelist,
          isShore: false,
          radioButton: "",
          isDeleted:false
        },
      ],
      selectedServiceYears: [],
    });
  }

  handleInputChanges(e,field) {
    const{dispatch}=this.props;
    this.state.miscinfo[field] = e.target.value;
    if(field=="miscType"){
      this.state.miscinfo.typeValue="";
      this.state.ApplicableServicesList=[];
      dispatch({
        type: "MiscApplicableServices",
        data: [],
      });
      this.state.miscinfo[field] = e.target.value;
    }else if(field==="equipmentName"){
      this.state.miscinfo[field]=e.target.value;
      this.setState({})
    }
 this.setState({});
  
  }
  handleRadioButtonChanges = (e, i) => {
    var lineitems = this.state.AddServiceYear;
    lineitems[i][e.target.name] = e.target.value;
    if (e.target.value === "Shore") {
      lineitems[i]["isShore"] = true;
    }else{
      lineitems[i]["isShore"] = false;
    }
    this.setState({ AddServiceYear: lineitems });
  };
  
  ClearInput() {     
   // this.props.dispatch(deleteAttachmentInBucket(this.state.miscinfo.attachmentGuid,this.state.miscinfo.attachmentName));
   let obj1 = {
    filename : this.state.miscinfo.attachmentName,
    guid : this.state.miscinfo.attachmentGuid,
  }
  fileDatas.push(obj1);
   this.setState({ file: "", fileName: "" });
    let obj = {
      FileName : "",
      Guid : ""
     };
     this.setState({ file: "", fileName: "" });
     this.props.dispatch({
      type: "postMiscAttachmentUploadSuccess",
      data: obj,
    });  
  }
  renderMiscTitle(state, val) {
    return (
      state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }
  renderEquipmentTitle(state, val) {
    return (
      state?.equipmentName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }
  render() {
    const{t}=this.props;
   const { ApplicableServices,ServiceTypeList } = this.state;
    console.log("service",ServiceTypeList)
    return (
      <div className="pb-3">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
            {t("content.Servicetype")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
           
              {this.state.AddServiceYear.map((x, index) => {
                return (
                  <>
                   <div className="row pt-2">
                    <div className="col-lg-5 col-sm-5">
               <select
                          className="form-control serviceyear"
                          name="serviceTypeId"
                          id={`chargeDescription${index}`}
                          value={x.serviceTypeId == 0 ? "" : x.serviceTypeId}
                          onChange={(e) =>
                            this.handleSelectYear(e, index, false)
                          }>
                          <option className="newservice" value="">{t("ClassScreen.SelectServiceYear")}</option>
                          {x &&
                            x?.servicetypelist?.map((name) => (
                              <option value={name.item}>
                                {name.serviceTypes}
                              </option>
                            ))}
                        </select>
                        <span id={`chargeDescription${index}ErrMsg`}
                           className="spanErrMsg ml-2"></span>
                     </div>
                     <div className="col-lg-5 col-sm-5" style={{ lineHeight: "0px" }}>
                            <RadioGroup
                              className="radio-value"
                              row
                              name="radioButton"
                              id={`isUnitPrice${index}`}
                              value={x.radioButton}
                              onChange={(e) =>
                                this.handleRadioButtonChanges(e, index)
                              }
                            >
                              <FormControlLabel
                                className="mt-0"
                                style={{marginBottom:"11px"}}
                                value="Ship"
                                control={<Radio color="default" size="small" />}
                                label={t("Generateservicerequestcontent.Ship")}
                              />
                              <FormControlLabel
                                className="mt-0"
                                style={{marginBottom:"11px"}}
                                value="Shore"
                                control={<Radio color="default" size="small" />}
                                label={t("Generateservicerequestcontent.Shore")}
                              />
                            </RadioGroup>
                           <span id={`isUnitPrice${index}ErrMsg`}
                              className="spanErrMsg ml-2"></span>
                      </div>
                          <div
                            className={`col-lg-2 col-sm-2 ${
                              this.state.isMiscNew ? "" : "d-none"
                            }`}
                          >
                            <div
                              className={`mr-3 pl-1 ${
                                index === 0 ? "d-none" : ""
                              }`}
                            >
                              <div
                                className="flex"
                                onClick={() => this.DeleteServiceYear(index)}
                              >
                                <MinusIcon />
                              </div>
                            </div>
                            <div
                              className={`mr-3 pl-1 ${
                                index === 0 ? "" : "d-none"
                              }`}
                            >
                              <div
                                className="flex"
                                onClick={() => this.AddNewServiceYear()}
                              >
                                <AddIcon />
                              </div>
                            </div>
                            </div>
                          </div>
                      </>
                );
              })}
          
            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}
            >
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={() => this.addApplicableType()}>
                {this.state.isMiscNew ? `${t("ComplianceandBudgetScreen.Submit")}` :`${t("EquipmentServiceTypes.Update")}`}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.showMiscModal(0, true)}>
                {" "}
                {t("ComplianceandBudgetScreen.Cancel")}{" "}
              </button>
            </div>
          </Modal.Body>
         </Modal>

        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const { EquipmentNameListAndId, MiscApplicableServices,Loading,t,MiscTypeofList,flagList,ClassList,TypeofShipList } = this.props;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}>
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}>
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}>
                    {t("MiscScreenContent.AddMisc")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-4">
                  <label className="form-label required">{t("MiscScreenContent.Title")}</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="misc"
                    value={this.state.miscinfo.lookupmisc}
                    placeholder={t("MiscScreenContent.Title")}
                    onChange={(e) => this.handleInputChanges(e,"lookupmisc")}
                  ></input>
                </div>
                <div className="col-lg-4">
                  <label className="form-label required">{t("ComplianceandBudgetScreen.Type")}</label>
                  <br></br>
                  <select className="form-control" name="flag" value={this.state.miscinfo.miscType} onChange={(e) => this.handleInputChanges(e,"miscType")}>
                      <option value="">{t("EditEquipmentScreenContent.SelectType")}</option>
                     
                    {MiscTypeofList &&
                        MiscTypeofList?.map((Miscname) => (
                          <option value={Miscname}>{Miscname}</option>
                        ))}  
                    </select>
                </div>
                {this.state.miscinfo.miscType==""?
                <div className="col-lg-4"></div>:
                this.state.miscinfo.miscType==="Ship Type"?
                  <div className="col-lg-4">
                    <div className="autocomplete-wrappers"
                     style={{
                      zIndex: this.state.openTypeValue && !Loading
                          ? 99999: 0,}}>
                     <label className="form-label"> {t("TopPaneContent.TypeofShip")}</label>
                      <br></br>
                      <Autocomplete
                        contentEditable={true}
                        open={!Loading ? this.state.openTypeValue : false}
                        onMenuVisibilityChange={(isOpen) => {
                          this.state.openTypeValue = isOpen;
                          this.setState({});
                        }}
                        value={this.state.miscinfo.typeValue}
                        inputProps={{ placeholder: `${t("ShipManagementContent.SelectTypeofShip")}` }}
                        items={TypeofShipList.list ?? []}
                        getItemValue={(item) => item}
                        shouldItemRender={this.renderMiscTitle.bind(this)}
                        renderMenu={(item) => (
                          <div className="dropdown">{item}</div>
                        )}
                        renderItem={(item, isHighlighted) => (
                          <div
                            className={`items ${
                              isHighlighted ? "selected-items" : ""
                            }`}>{item}</div>
                        )}
                        onChange={(e) =>
                          this.handleInputChanges(e, "typeValue")
                        }
                        onSelect={(value, item) =>
                          this.handleSelectChange(value, "typeValue", item)
                        }
                      />
                    </div>
                  </div>:this.state.miscinfo.miscType==="Flag Type"?
                   <div className="col-lg-4">
                   <div className="autocomplete-wrappers"
                    style={{
                     zIndex: this.state.openTypeValue && !Loading? 99999: 0,}}>
                       <label className="form-label">{t("TopPaneContent.Flag")}</label>
                     <br></br>
                     <Autocomplete
                       contentEditable={true}
                       open={!Loading ? this.state.openTypeValue : false}
                       onMenuVisibilityChange={(isOpen) => {
                         this.state.openTypeValue = isOpen;
                         this.setState({});}}
                       value={this.state.miscinfo.typeValue}
                       inputProps={{ placeholder: `${t("ShipManagementContent.SelectFlag")}` }}
                       items={flagList ?? []}
                       getItemValue={(item) => item}
                       shouldItemRender={this.renderMiscTitle.bind(this)}
                       renderMenu={(item) => (
                         <div className="dropdown">{item}</div>
                       )}
                       renderItem={(item, isHighlighted) => (
                         <div
                           className={`items ${
                             isHighlighted ? "selected-items" : ""
                           }`}> {item}</div>)}
                       onChange={(e) =>
                         this.handleInputChanges(e, "typeValue")}
                       onSelect={(value, item) =>
                         this.handleSelectChange(value, "typeValue", item)}
                     />
                   </div>
                 </div>:
                 this.state.miscinfo.miscType==="Class Type"?
                  <div className="col-lg-4">
                  <div className="autocomplete-wrappers"
                   style={{
                    zIndex: this.state.openTypeValue && !Loading ? 99999: 0,}}>
                    <label className="form-label">{t("TopPaneContent.Class")}</label>
                    <br></br>
                    <Autocomplete
                      contentEditable={true}
                      open={!Loading ? this.state.openTypeValue : false}
                      onMenuVisibilityChange={(isOpen) => {
                        this.state.openTypeValue = isOpen;
                        this.setState({});
                      }}
                      value={this.state.miscinfo.typeValue}
                      inputProps={{ placeholder: `${t("TopPaneContent.Class")}` }}
                      items={ClassList ?? []}
                      getItemValue={(item) => item}
                      shouldItemRender={this.renderMiscTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}>
                          {item}</div>
                      )}
                      onChange={(e) =>
                        this.handleInputChanges(e, "typeValue")
                      }
                      onSelect={(value, item) =>
                        this.handleSelectChange(value, "typeValue", item)
                      }
                    />
                  </div>
                </div>:<></>}

                <div className="col-lg-4">
                  <label className="form-label">{t("FlagScreen.Attachment")}</label>
                  <br></br>
                  <div class="input-group ">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                      {t("CommonText.BrowseFile")}
                        <input
                          type="file"
                          id="files"
                          name="fileName"
                          style={{ marginRight: 40 }}
                          onChange={(e) => this.handleFileInputChange(e,"fileName")}
                          onClick={(event) => {
                            event.currentTarget.value = null;
                          }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder={t("CommonText.Nofilechoosen")}
                      value={this.state.fileName}
                    />
                    {this.state.fileName ? (
                      <div
                        class="input-group-append"
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-times input-group-text padding-top-10px"
                          aria-hidden="true"
                          onClick={() => this.ClearInput()}
                        ></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="search-filter-box">
               
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}>
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}>
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}>
                     {t("ClassScreen.ApplicableServices")}
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                <div className="col-lg-4">
                    <div className="autocomplete-wrappers"
                     style={{
                      zIndex: this.state.openEquipment && !Loading
                          ? 99999
                          : 0,
                    }}>
                      <label className="form-label required">{t("ShipEquipmentStatusScreen.EquipmentName")}</label>
                      <br></br>
                      <Autocomplete
                        contentEditable={true}
                        ref={this.autocompleteRef}
                        open={!Loading ? this.state.openEquipment : false}
                        onMenuVisibilityChange={(isOpen) => {
                          this.state.openEquipment = isOpen;
                          this.setState({});
                        }}
                        value={this.state.miscinfo.equipmentName}
                        inputProps={{ placeholder: `${t("ShipEquipmentStatusScreen.EquipmentName")}` }}
                        items={EquipmentNameListAndId ?? []}
                        getItemValue={(item) => item.equipmentName}
                        shouldItemRender={this.renderEquipmentTitle.bind(this)}
                        renderMenu={(item) => (
                          <div className="dropdown">{item}</div>
                        )}
                        renderItem={(item, isHighlighted) => (
                          <div
                            className={`items ${
                              isHighlighted ? "selected-items" : ""
                            }`}
                          >
                            {item.equipmentName}&nbsp; (
                            {item.category &&
                            (item.capacity || item.equipmentType)
                              ? item.category + ","
                              : item.category
                              ? item.category
                              : ""}
                            &nbsp;{" "}
                            {item.capacity &&
                            (item.category || item.equipmentType)
                              ? item.capacity + ","
                              : item.capacity
                              ? item.capacity
                              : ""}
                            &nbsp;{" "}
                            {item.equipmentType ? item.equipmentType : ""})
                          </div>
                        )}
                        onChange={(e) =>
                          this.handleInputChanges(e, "equipmentName")
                        }
                        onSelect={(value, item) =>
                          this.handleEquipmentSelectChange(value, "equipmentName", item)
                        }
                      />
                    </div>
                  </div>
                  </div>
                {MiscApplicableServices && MiscApplicableServices.length ? (
                  MiscApplicableServices.map((item, index) => (
                    <div className="card click m-3"
                      style={{backgroundColor: "#f0f0f0",overflow: "hidden",position: "relative"}}>
                      <div className="p-3">
                        <div className="resource-list-auth-date">
                          <div className="row">
                            <div className="col-sm-9 col-md-10 col-9 m-auto">
                              <div className="row">
                                <div className="col-sm-4">
                                  <span>
                                    <strong>{ this.state.miscinfo.miscType==="Ship Type"?`${t("TopPaneContent.TypeofShip")}`:this.state.miscinfo.miscType==="Class Type"?`${t("TopPaneContent.Class")}`:this.state.miscinfo.miscType==="Flag Type"? `${t("TopPaneContent.Flag")}`:""}{" "}:{" "} </strong>
                                    {item.typeValue}
                                  </span>
                                </div>
                                <div className="col-sm-8">
                                  <span>
                                    <strong>{t("ShipEquipmentStatusScreen.EquipmentName")} : </strong>
                                    {item.equipmentName}&nbsp; (
                                    {item.category &&
                                    (item.capacity || item.equipmentType)
                                      ? item.category + ","
                                      : item.category
                                      ? item.category
                                      : ""}
                                    &nbsp;{" "}
                                    {item.capacity &&
                                    (item.category || item.equipmentType)
                                      ? item.capacity + ","
                                      : item.capacity
                                      ? item.capacity
                                      : ""}
                                    &nbsp;{" "}
                                    {item.equipmentType
                                      ? item.equipmentType
                                      : ""}
                                    )
                                  </span>
                                </div>
                                <div className="col-sm-4 mt-1">
                                  <span>
                                    <strong>{t("content.Servicetype")} : </strong>
                                    {item.serviceType}
                                  </span>
                                </div>
                                <div className="col-sm-4 mt-1">
                                  <span>
                                    <strong>{t("ComplianceandBudgetScreen.Type")}: </strong>
                                    {item.radioButton}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-3 col-md-2 col-3 m-auto">
                              <div className="text-right">
                              <i
                                  className="fa fa-edit fa-lg click m-1 px-1"
                                  onClick={() =>
                                    this.showMiscModal(
                                      item.Id,false, item.equipmentId)}
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                                <i
                                  className="fa fa-trash click m-1 px-2"
                                  onClick={() =>
                                    this.deleteApplicableType(index)
                                  }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className="card m-3"
                    style={{ overflow: "hidden", position: "relative" }}
                  >
                    <div class="container">
                      <h6 className="resource-list-title no-item-card">
                     {t("CommonText.NoService")} 
                      </h6>
                    </div>
                  </div>
                )}
           </div>
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.AddMisc()}>
                      {" "}
                    {t("ComplianceandBudgetScreen.Submit")}{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.CancelAddMisc()}>
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
     
    );
  }

  CancelAddMisc() {
    fileDatas = [];
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.dispatch({type: "MiscApplicableServices",data: []});
    this.props.history.push("/Home/LookupMisc");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    Loading: state.PageLoaderReducer.loading,
    EquipmentNameListAndId:state.MasterScreenReducer.EquipmentNameListAndId || [],
    MiscAttachment:state.lookupReducer.MiscAttachment,
    applicableServiceType: state.MasterScreenReducer.applicableServiceTypeInterval,
    MiscApplicableServices: state.MasterScreenReducer.NewMiscApplicableServices,
    serviceTypeList: state.MasterScreenReducer.applicableServiceTypeInterval || [],
    MiscTypeofList: state.MasterScreenReducer.MiscTypeofList,
    ClassList: state.MasterScreenReducer.ClassList,
    TypeofShipList: state.MasterScreenReducer.TypeofShipList,
    flagList: state.MasterScreenReducer.flagList,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MiscAdd)));